"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    border: 'none',
    padding: '6px',
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: _theme.default.typography.pxToRem(16),
    whiteSpace: 'normal'
  }
});
var _default = exports.default = useStyles;